const kindfulHandler = function (next) {

	// handle all kindful embeds
	const kindfulEls = next.querySelectorAll('.btn[data-kindfulid]')

	if (kindfulEls.length < 1)
		return // didn't find any images, exiting...

	kindfulEls.forEach(el => {
		let kindfulEmbedId = el.dataset.kindfulid

		if (kindfulEmbedId.length > 0) {
			// console.log("kindful btn ID found:", kindfulEmbedId)
			// append kindful embed script
			var script = document.createElement('script');
			script.src = `https://fame.kindful.com/embeds/${kindfulEmbedId}/init.js`;
			script.dataset.embedId = kindfulEmbedId;
			script.dataset.stylesOff = 'true';
			// script.dataset.lookupType = "jquery-selector";
			script.dataset.lookupValue = `#kindful-donate-btn-${kindfulEmbedId}`;
			script.dataset.isKindful = 'true'; // used to remove scripts on page unmount
			document.body.appendChild(script);
		}
	})

}

export default kindfulHandler
